import React, { Suspense, useEffect } from "react";
import useDebounce from "../../hooks/useDebounce";
import dynamic from "next/dynamic";
import useStore, { StoreState } from "../../context/useStore";

const Auth = dynamic(() => import("../Auth"), {
  suspense: true,
});
const Navbar = dynamic(() => import("../Navbar"), {
  suspense: true,
});
const Footer = dynamic(() => import("../Footer"), {
  suspense: true,
});
const MobileFooter = dynamic(() => import("../MobileFooter"), {
  suspense: true,
});

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navbar = useStore((state: StoreState) => state.dialog);
  const auth = useStore((state: StoreState) => state.auth);
  const setAuth = useStore((state: StoreState) => state.setAuth);
  const setProperties = useStore((state: StoreState) => state.setProperties);

  const _onLoad = async () => {
    window.addEventListener("unauth", () => {
      setAuth({
        login: false,
        verify: false,
      });
    });

    const { featured, res } = await (await import("./auth.api")).default();
    if (res?.ok) {
      if (!auth.login) {
        setAuth({
          login: true,
          name: res.data.name,
          role: res.data.role,
          verify: res.data.verify,
          email: res.data.email,
          phone: res.data.phone,
        });
        setProperties(featured?.data || []);
      }
    }
  };

  const onLoad = useDebounce(_onLoad, 500);

  useEffect(() => {
    onLoad();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="relative min-h-screen flex flex-col">
        <Suspense fallback={<></>}>
          <Navbar />
        </Suspense>
        <div className="flex-1">{children}</div>
        <div className="lg:block hidden">
          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            <Footer />
          </Suspense>
        </div>
        <div className="block lg:hidden">
          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            <MobileFooter />
          </Suspense>
        </div>
      </div>
      <Suspense
        fallback={
          <>
            <p>Loading...</p>
          </>
        }
      >
        <Auth open={navbar.open} />
      </Suspense>
    </>
  );
};

export default Layout;
